import EntityDetails from './EntityDetails';

export default EntityDetails;



// WEBPACK FOOTER //
// ./src/components/forms/EntityDetailsForm/index.jsx